module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Arrows-1ddac9ec10fd388ec7114cc138751c3c.svg";